import React from 'react';
import {StyleProp, Text, View, ViewStyle} from 'react-native';
import {images} from '../../../../../assets/icons';
import {useStyles} from '../../../../../shared/hooks/styles';
import {DeviceSize} from '../../../../../shared/theme/helpers';

interface TechnicalWorkPlaceholderProps {
  style?: StyleProp<ViewStyle>;
}

export function TechnicalWorkPlaceholder({style}: TechnicalWorkPlaceholderProps) {
  const styles = useStyles(({theme, mediaOnly}) => ({
    container: {
      alignItems: 'center',
      justifyContent: 'center',
    },
    text: {
      textAlign: 'center',
      color: theme.color.textColor,
      ...mediaOnly(
        DeviceSize.mobile,
        {
          maxWidth: '90%',
          ...theme.fonts.h6,
        },
        {
          maxWidth: '70%',
          ...theme.fonts.h5,
        },
      ),
    },
    image: {
      marginBottom: 24,
      width: 96,
      height: 95,
    },
  }));

  return (
    <View style={[styles.container, style]}>
      <View style={styles.image}>
        <images.TechnicalWork />
      </View>
      <Text style={[styles.text, {marginBottom: 30}]}>
        Мы проводим плановые технические работы по&nbsp;обновлению нашей нейросети.
      </Text>
      <Text style={styles.text}>Приносим извинения за&nbsp;неудобства. </Text>
      <Text style={styles.text}>Скоро вернёмся в&nbsp;строй!</Text>
    </View>
  );
}
